requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    class TransparentHeader extends HTMLElement {
      constructor() {
        super();

        this.invertClass = 'header-section--style-inverted';
        this.sectionSelector = '[data-invert-header-colors]';
        this.onScrollHandler = this.onScroll.bind(this);
        this.onResizeHandler = this.onResize.bind(this);
        this.onLazySectionLoadedHandler = this.onLazySectionLoaded.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.headerSection = this.querySelector('header-section');
        this.header = this.querySelector('header');
        this.sections = new Set();

        if (this.headerSection.classList.contains('header-section--first-section-inverted')) {
          document.querySelector('main > .shopify-section').setAttribute('data-invert-header-colors', '');
        }

        this.collectSections();
        this.updateHeaderSpacing();
        this.updateHeaderState();
        document.body.classList.add('body-transparent-header');

        window.addEventListener('throttle30fpsScroll', this.onScrollHandler, {
          passive: true
        });
        window.addEventListener('throttle30fpsResize', this.onResizeHandler);
        window.addEventListener('LazySectionLoaded', this.onLazySectionLoadedHandler);
      }

      disconnectedCallback() {
        window.removeEventListener('throttle30fpsScroll', this.onScrollHandler);
        window.removeEventListener('throttle30fpsResize', this.onResizeHandler);
        window.removeEventListener('LazySectionLoaded', this.onLazySectionLoadedHandler);

        if (this.headerSection) {
          this.headerSection.classList.remove(this.invertClass);
        }

        this.sections = new Set();
        this.initialized = false;
      }

      collectSections() {
        this.sections = new Set(document.querySelectorAll(this.sectionSelector));
      }

      onLazySectionLoaded(event) {
        if (!event.detail || !event.detail.element) return;

        const target = event.detail.element.querySelector(this.sectionSelector) ||
          (event.detail.element.matches(this.sectionSelector) ? event.detail.element : null);

        if (target) {
          this.sections.add(target);
          this.updateHeaderState();
        }
      }

      onScroll() {
        this.updateHeaderState();
      }

      onResize() {
        this.updateHeaderSpacing();
        this.updateHeaderState();
      }

      updateHeaderSpacing() {
        if (!this.header) return;

        const headerHeight = this.header.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--transparent-header-spacing', `${headerHeight}px`);
      }

      updateHeaderState() {
        if (!this.header) return;

        const headerRect = this.header.getBoundingClientRect();
        const requiredOverlap = headerRect.height * 0.5;

        if (!requiredOverlap || !this.sections.size) {
          this.headerSection.classList.remove(this.invertClass);
          return;
        }

        let shouldInvert = false;

        for (const section of this.sections) {
          if (!section || !section.isConnected) {
            this.sections.delete(section);
            continue;
          }

          const sectionRect = section.getBoundingClientRect();
          const overlapHeight = Math.min(headerRect.bottom, sectionRect.bottom) - Math.max(headerRect.top, sectionRect.top);

          if (overlapHeight > requiredOverlap) {
            shouldInvert = true;
            break;
          }
        }

        this.headerSection.classList.toggle(this.invertClass, shouldInvert);
      }
    }

    customElements.define('transparent-header', TransparentHeader);
  });
});